import React from "react";
import "./slider.css";

import Carousel from 'react-bootstrap/Carousel';

function Slider() {
  return (
    <Carousel>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://cdn.seeklearning.com.au/media/images/career-guide/module/backend-developer-module.jpg"
          alt="First slide"
        />
        <Carousel.Caption>
          <h3><strong>Développement d'interface utilisateur</strong></h3>
          
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://images.ctfassets.net/wp1lcwdav1p1/585Wul8GGcz8X4duQ8ifmz/813766bae0ad07e41a7e82ecbe2439b8/ux-designer.JPG?w=1500&h=680&q=60&fit=fill&f=faces&fm=jpg&fl=progressive"
          alt="Second slide"
        />

        <Carousel.Caption>
          <h3>Développement Coté Serveur</h3>
        
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://miro.medium.com/max/1400/1*Nrx2-4b0hsrCXhxYFOfDXA.jpeg"
          alt="Third slide"
        />

        <Carousel.Caption>
          <h3>UI/UX Designe</h3>
       
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Slider;
